export default __webpack_public_path__ + "static/media/three-red.47ce23b9.svg";